import React from "react";
import { useSettings } from "../../hooks/useSettings";

export default function PublicFooter() {
  const { settings } = useSettings();

  return (
    <footer className="pm-footer">
      <div className="pm-footer__inner">
        <div>
          <div className="pm-footer__brand">{settings?.name || "Positive Moves"}</div>
          <p>{settings?.footer_text || "Building careers, one campus at a time."}</p>
        </div>
        <div className="pm-footer__cols">
          <div>
            <h4>Programme</h4>
            <a href="#about">About us</a>
            <a href="#opportunities">Open campuses</a>
            <a href="#process">Hiring process</a>
          </div>
          <div>
            <h4>Apply</h4>
            <a href="#apply">Start application</a>
            <a href="#eligibility">Eligibility</a>
          </div>
        </div>
      </div>
      <div className="pm-footer__bottom">
        © {new Date().getFullYear()} {settings?.name || "Positive Moves Consulting"}. All rights reserved.
      </div>
    </footer>
  );
}
